import { useEffect, useState } from 'react';
import { sendRequest } from '../api/shootAPI';
import API from '../api/endpoints';

const cache = new Map();

// Resolves a member's stored profile-picture path into a usable URL.
// Direct URLs (http/data/blob) pass through; S3 keys are exchanged for a
// signed URL via API.MEMBER.fileUrl and cached. Returns null when none.
export default function useProfilePictureUrl(profilePicture, id) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let mounted = true;

    const resolve = async () => {
      const raw = `${profilePicture || ''}`.trim();
      if (!raw) {
        if (mounted) setUrl(null);
        return;
      }
      if (/^(https?:)?\/\//.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
        if (mounted) setUrl(raw);
        return;
      }
      if (!id) {
        if (mounted) setUrl(raw);
        return;
      }
      const key = `${id}:${raw}`;
      if (cache.has(key)) {
        if (mounted) setUrl(cache.get(key));
        return;
      }
      const res = await sendRequest({
        method: 'get',
        url: API.MEMBER.fileUrl(id),
        params: { fileName: raw },
      });
      if (res.success && res.data?.url) {
        cache.set(key, res.data.url);
        if (mounted) setUrl(res.data.url);
        return;
      }
      if (mounted) setUrl(null);
    };

    resolve();
    return () => { mounted = false; };
  }, [profilePicture, id]);

  return url;
}
